import React from 'react';
import { motion } from 'framer-motion';
import { Breadcrumb } from '../components/Breadcrumb';

export default function TermsPage() {
  return (
    <div className="page-transition min-h-screen bg-stone-50">
      <section className="bg-white border-b border-stone-100">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <Breadcrumb items={[{ label: 'Terms & Conditions' }]} />
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl p-8 md:p-12 shadow-soft"
          >
            <h1 className="font-heading font-bold text-3xl text-stone-900 mb-8">
              Terms & Conditions
            </h1>

            <div className="prose prose-stone max-w-none">
              <p className="text-stone-600 mb-6">
                Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                1. Acceptance of Terms
              </h2>
              <p className="text-stone-600 mb-6">
                By accessing and using the Dream Field Agri solution website, you accept and agree to be bound 
                by these Terms and Conditions. If you do not agree to these terms, please do not use our website.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                2. Products and Services
              </h2>
              <p className="text-stone-600 mb-6">
                Dream Field Agri solution provides agricultural seeds and related products. All product 
                descriptions, specifications, and images are provided for informational purposes. We reserve 
                the right to modify product offerings without prior notice.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                3. Product Quality and Germination
              </h2>
              <p className="text-stone-600 mb-4">
                While we strive to maintain the highest quality standards:
              </p>
              <ul className="list-disc pl-6 text-stone-600 mb-6 space-y-2">
                <li>Germination rates are indicative and may vary based on storage and planting conditions</li>
                <li>Actual crop yields depend on various factors including soil, weather, and farming practices</li>
                <li>We recommend following the cultivation guidelines provided with each product</li>
                <li>Seeds should be stored in cool, dry conditions as specified</li>
              </ul>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                4. Dealer Inquiries and Partnerships
              </h2>
              <p className="text-stone-600 mb-6">
                Submitting a dealer inquiry does not guarantee partnership approval. All applications are 
                subject to review and verification. We reserve the right to accept or reject applications 
                at our discretion.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                5. Intellectual Property
              </h2>
              <p className="text-stone-600 mb-6">
                All content on this website, including text, graphics, logos, and images, is the property 
                of Dream Field Agri solution and is protected by intellectual property laws. You may not 
                reproduce, distribute, or use any content without our written permission.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                6. Limitation of Liability
              </h2>
              <p className="text-stone-600 mb-6">
                Dream Field Agri solution shall not be liable for any indirect, incidental, special, or 
                consequential damages arising from the use of our products or services. Our liability is 
                limited to the purchase price of the products.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                7. Indemnification
              </h2>
              <p className="text-stone-600 mb-6">
                You agree to indemnify and hold harmless Dream Field Agri solution and its officers, 
                employees, and agents from any claims, damages, or expenses arising from your use of 
                the website or violation of these terms.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                8. Governing Law
              </h2>
              <p className="text-stone-600 mb-6">
                These Terms and Conditions are governed by the laws of the jurisdiction in which 
                Dream Field Agri solution is registered. Any disputes shall be subject to the exclusive 
                jurisdiction of the courts in that jurisdiction.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                9. Changes to Terms
              </h2>
              <p className="text-stone-600 mb-6">
                We reserve the right to modify these Terms and Conditions at any time. Changes will be 
                effective immediately upon posting to the website. Your continued use of the website 
                constitutes acceptance of the modified terms.
              </p>

              <h2 className="font-heading font-semibold text-xl text-stone-900 mt-8 mb-4">
                10. Contact Information
              </h2>
              <p className="text-stone-600 mb-6">
                For any questions regarding these Terms and Conditions, please contact us:
              </p>
              <div className="bg-stone-50 rounded-lg p-4 text-stone-600">
                <p><strong>Dream Field Agri solution</strong></p>
                <p>123 Agriculture Road</p>
                <p>Farmville, State 12345</p>
                <p>Email: agrisolutiondreamfield@gmail.com</p>
                <p>Phone: +1 234 567 890</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
